/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
//import UserName from "./UserName";
//import logo from "../assets/img/MM_FullMark_Reg_White.svg";
import logo from "../../assets/img/Orbit_logo.svg";
import "../../assets/stylesheets/Header.scss";
import LostDataModal from "./LostDataModal";
import { useSelector } from "react-redux";

const Header = ({ isStartApp = false, currentFormChanged = false }) => {
  const { oktaAuth, authState } = useOktaAuth();
  const [showModal, setShowModal] = useState(false);
  const { showLogoutModal } = useSelector((state) => state.logoutModal);

  const logout = async () => {
    await oktaAuth.signOut();
  };

  const handleModalOpen = () => {
    if (
      (isStartApp === true && currentFormChanged === true) ||
      !!showLogoutModal
    ) {
      setShowModal(true);
    } else {
      logout();
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
  };
  return (
    <>
      <nav
        role="navigation"
        className={
          isStartApp ? "mm-navigation start-app-header" : "mm-navigation"
        }
        aria-label="banner navigation"
      >
        <div className="navbar navbar-expand-xl">
          <div className="container" id="mm-onboarding-logo">
            <a
              href="/"
              rel="noopener noreferer"
              className="navbar-brand"
              id="mm-onboarding-custom-logo"
            >
              <img alt="MassMutual" src={logo} id="mm-logo" />
            </a>
            <div className="navbar-nav" style={{ flexDirection: "row" }}>
              <div className="nav-item">
                <a
                  style={{ color: "#ffffff", cursor: "pointer" }}
                  data-rb-event-key="logout"
                  className="logout nav-link"
                  role="button"
                  onClick={handleModalOpen}
                >
                  <span className="icon-logout-white"></span>{" "}
                  <span style={{ color: "white" }}>Log Out</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <LostDataModal
        isOpen={showModal}
        handleClose={handleModalClose}
        handleProceed={logout}
      />
    </>
  );
};

export default Header;
